import React from "react";
import { Row } from "react-bootstrap";

import { usePresentationBySlug } from "hooks/query";

import "./Header.css";
import Buildning from "components/Svg/Buildning";
import Users from "components/Svg/Users";
import Award from "components/Svg/Award";
import Globe from "components/Svg/Globe";

export default function Header() {
    const { data } = usePresentationBySlug();

    return (
        
         <div className="Header-container border-presentation margin-top">    
                <div className="customer-card">
                    <img className="m-2 logo-size" src={data.logoColor}></img>
                    {/* <div className="statsCompany">
                        <div className="bgSats">
                            <div className="title">Kontor:</div>
                            <Buildning/>
                            <div className="value">{data.num_office}</div>
                        </div>
                        <div className="bgSats">
                            <div className="title">Anställda:</div>
                             <Users/>
                            <div className="value">{data.employees}</div>
                        </div>
                        <div className="bgSats">
                            <div className="title">Grundat</div>
                            <Award/>
                            <div className="value">{data.founded}</div>
                        </div>                        
                    </div> */}
                    <div className="bgSats pt-3">
                    <Globe/> <a href={data.website}>{data.website}</a>
                    </div>
                </div>        
                <div className="image-wrapper no-mobile">
                    <img id="image-presentation" src={data.img} alt="TODO" loading="lazy" />
                </div>               
        </div>       
        
    );
}
